const currency = (value: any) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number(value ?? 0));

const percentage = (value: any) => {
  const num = Number(value ?? 0);
  return num === 0 ? "—" : `${num}%`;
};

export const SDAppendixJson = [
  { field: "policyYear", header: "Policy Year" },
  { field: "insuredAge", header: "Insured Age" },
  { field: "totalPolicyPremium", header: "Total Policy Premium", formatter: currency },
  { field: "planLoanRate", header: "Plan Loan Rate", formatter: percentage },
  { field: "minimumAFR", header: "Minimum AFR", formatter: percentage },
  {
    field: "endOfYearOutstandingLoanBalance",
    header: "EOY Outstanding Loan Balance",
    formatter: currency,
  },
  {
    field: "estimatedLoanPayoffOrIncome",
    header: "Estimated Loan Payoff / Income",
    formatter: currency,
  },
  {
    field: "illustratedPlanAccumulatedValue",
    header: "Illustrated Plan Accumulated Value",
    formatter: currency,
  },
  {
    field: "illustratedPlanSurrenderValue",
    header: "Illustrated Plan Surrender Value",
    formatter: currency,
  },
];

export const headerColumnGroupSDAppendix = {
  "": ["policyYear", "insuredAge"],
  "Plan Payments": ["totalPolicyPremium"],
  "Interest Rates": ["planLoanRate", "minimumAFR"],
  "Loan Info": ["endOfYearOutstandingLoanBalance"],
  "Plan Projections": [
    "estimatedLoanPayoffOrIncome",
    "illustratedPlanAccumulatedValue",
    "illustratedPlanSurrenderValue",
  ],
};
